/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PlacementType {
    Left = 0,
    Right = 1,
    LeftAndRight = 2,
}
